export const CHAT_SEARCH_HISTORY_KEY = "chat_search_history";

const MAX_ITEMS = 10;

export function getChatSearchHistory(): string[] {
  try {
    const raw = localStorage.getItem(CHAT_SEARCH_HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === "string");
  } catch {
    return [];
  }
}

export function addChatSearchHistory(query: string): string[] {
  const trimmed = query.trim();
  if (!trimmed) return getChatSearchHistory();

  const withoutDup = getChatSearchHistory().filter((t) => t !== trimmed);
  withoutDup.unshift(trimmed);
  const next = withoutDup.slice(0, MAX_ITEMS);
  localStorage.setItem(CHAT_SEARCH_HISTORY_KEY, JSON.stringify(next));
  return next;
}

export function removeChatSearchHistoryAt(index: number): string[] {
  const list = getChatSearchHistory();
  if (index < 0 || index >= list.length) return list;
  list.splice(index, 1);
  localStorage.setItem(CHAT_SEARCH_HISTORY_KEY, JSON.stringify(list));
  return list;
}
